import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { AllProductsRoot, Spacer } from './AllProducts.styles'
import { Hero } from './components/Hero'
import { ProductCatalog } from './components/ProductCatalog'
import { Timeline } from 'features/Recipes/components/Timeline'
import { RecipeHero } from 'features/Recipes/components/RecipeHero'
import { RecipeFooter } from 'features/Recipes/components/RecipeFooter'
import { Reviews } from 'features/Recipes/components/Reviews'
import { Footer } from 'components/Footer'
import { ProductPageReviews } from 'fixtures/review'
type ProductsOwnProps = ComponentProps<typeof AllProductsRoot>
export type ProductsProps = ProductsOwnProps & {}

export const AllProducts = (_props: ProductsProps) => {
  const { t } = useTranslation()
  const { melissa, mariah, sunny } = ProductPageReviews
  const header = <Header hideBrandCopy />
  

  return (
    <AllProductsRoot>
      <Layout hideCTA header={header}>
        <Hero />
        <ProductCatalog />
        <Timeline />
        <RecipeHero ctaWidth='large' order='1' background='secondary-100' ctaLink='/recipes' ctaText={t('products:recipes.cta1')} />
        <Spacer />
        <Reviews icon background='secondary-150' reviews={[melissa, mariah, sunny]}/>
        <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')} bg='secondary-150' />
        <Footer />
      </Layout>
    </AllProductsRoot>
  )
}

AllProducts.displayName = 'AllProducts'
